export const CBUHeaderElements = [
  { label: "Cuenta Cooperativa", value: "nombreCuenta", align: "inherit" },
  { label: "CUIT/CUIL Cuenta Cooperativa", value: "cuit", align: "inherit" },
  { label: "Nombre de banco", value: "nombreBanco", align: "inherit" },
  { label: "Tipo de cuenta", value: "tipoCuenta", align: "inherit" },
  { label: "N° de cuenta bancaria", value: "nroCuenta", align: "inherit" },
  { label: "N° de CBU bancario", value: "cbu", align: "inherit" },
];
